import React from 'react'
import { Router, Location } from "@reach/router"
import { SwitchTransition } from 'react-transition-group';
import Fade from '@mui/material/Fade';


const FadeTransitionRouter = (props) => {
  return <Location>
    {({ location }) => (
      <SwitchTransition>
        <Fade key={location.key}>
          <div key={`${location.key}-fade`} className="transition-fade">
            <Router location={location} className="router">
              {props.children}
            </Router>
          </div>
        </Fade>
    </SwitchTransition>)}
  </Location>
}

export default FadeTransitionRouter